import { createContext, use } from 'react';

import type { AppServices } from './services';

export const ServicesContext = createContext<AppServices | null>(null);

export function useServices(): AppServices {
  const services = use(ServicesContext);
  if (!services) throw new Error('useServices must be used inside <AppProviders>');
  return services;
}

/** The typed Lions API client (openapi-fetch) with bearer token and refresh-on-401. */
export function useApiClient() {
  return useServices().client;
}
